import { Modal, Switch } from "@material-ui/core";
import React, { useState, useEffect } from "react";

const PhoneComparisonModal = ({
  showComparisonModal,
  setShowComparisonModal,
  plans_list = [],
}) => {
  const [isAnnual, setIsAnnual] = useState(true);
  console.log("Fetched plan data:", plans_list); // Manage toggle state

  const handleToggle = () => {
    setIsAnnual(!isAnnual);
  };
  return (
    <Modal
      open={showComparisonModal}
      onClose={() => setShowComparisonModal(false)}
    >
      <div className="w-100 h-100 d-flex align-items-center justify-content-center subscriptions-plan-modal">
        <div className="w-100 bg--white subscriptions-plan-modal-content radius--10">
          <div class="subscriptions-plan-modal-header border--bottom-1 p-3 radius--top-left-right-10">
            <button
              type="button"
              class="close"
              onClick={() => setShowComparisonModal(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="font--18 text--black mb-0">
              NxaTel Business Phone Full Comparison Plan
            </h4>
          </div>
          <div class="subscriptions-plan-modal-body  p--15">
            <div className="subscriptions-plan-section">
              {/* header start here */}
              <div
                className="subscriptions-plan-header d-flex align-items-center gap--15"
                style={{
                  position: "sticky",
                  top: " 0",
                  zIndex: "1000",
                  backgroundColor: "#fff",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "15px",
                }}
              >
                <div className="subscription-left-content w--260 w--min-220 d-flex align-items-center gap--10">
                  <div
                    className={`toggle-wrapper ${
                      isAnnual ? "annual" : "monthly"
                    }`}
                    onClick={() => setIsAnnual(!isAnnual)}
                  >
                    <span
                      className={`toggle-option ${!isAnnual ? "active" : ""}`}
                    >
                      Monthly
                    </span>
                    <span
                      className={`toggle-option ${isAnnual ? "active" : ""}`}
                    >
                      Annual
                    </span>
                  </div>
                </div>
                <div className="subscription-right-content w-100 d-flex align-items-center gap--15">
                  <div className="w-100 w--min-220 text-left "></div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Start-Up</h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Scale-Up</h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">
                      Professional
                    </h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Enterprise</h3>
                  </div>
                </div>
              </div>
              {/* container start here */}
              <div className="subscriptions-plan-container w-100  ">
                {/*Bussiness Phone */}

                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      NxaTel Phone
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* Monthly Price */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          {isAnnual
                            ? "Annual Price Per User"
                            : "Monthly Price Per User"}
                        </p>
                      </div>

                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => {
                          const planCost = isAnnual
                            ? plan.yearly_cost?.amount
                            : plan.monthly_cost?.amount;
                          const currencySymbol =
                            plan.currency === "USD"
                              ? "$"
                              : plan.currency === "ZAR"
                              ? "R"
                              : "N/A"; // Add more currencies as needed

                          return (
                            <div
                              key={plan.planID}
                              className="w-100 w--min-220 text-center"
                            >
                              {plan.planID >= 9 && plan.planID <= 12
                                ? `${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`
                                : "Custom Pricing"}
                            </div>
                          );
                        })
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/*Annual Price per user -Up-to- 16% */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Annual Discount up to 18% Per User
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12
                              ? `${plan.annual_plan_discount}%`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* 24 Month Price*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          24 Month Discount up to 20% Per User
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12
                              ? `${plan.two_year_plan_discount}%`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/*Trial */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">Trial</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />{" "}
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*Call Minutes */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Call Minutes (FUP)
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12
                              ? `${plan.voice_minute}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* Voice Features */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Voice Features
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Standard
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited(FUP)
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited(FUP)
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited(FUP)
                      </div>
                    </div>
                    {/* Minute Rate */}

                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Minute Rate(Domestic RSA Only)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">0.75</div>
                      <div className="w-100 w--min-220 text-center">0.65</div>
                      <div className="w-100 w--min-220 text-center">0.55</div>
                      <div className="w-100 w--min-220 text-center">0.45</div>
                    </div>
                    {/* Billing Type */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Minutes Billing Type
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Per minutes, <br />
                        per second billing
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Per minutes,
                        <br /> per second billing
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Per minutes, <br />
                        per second billing
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Per minutes, <br />
                        per second billing
                      </div>
                    </div>
                    {/* Out of Bundle Rate */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Out of Bundle Rate, Billing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Billed per minute,
                        <br /> as per rate
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Billed per minute,
                        <br /> as per rate
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Billed per minute, <br />
                        as per rate
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Billed per minute,
                        <br /> as per rate
                      </div>
                    </div>
                    {/* Team Size */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">Team Size</p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12 ? (
                              <p className="text--black">
                                {plan.min_user}-{plan.max_user}
                              </p>
                            ) : (
                              <p>N/A</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* Phone Number Included in the Plan */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Phone number included in the plan
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12 ? (
                              <p className="text--black">
                                {plan.free_did_number} Local <br />
                                or National
                              </p>
                            ) : (
                              <p>N/A</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* Price of Additional Number */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Price of Each Additional Number, per month (ZAR)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R144.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R144.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R144.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R144.00
                      </div>
                    </div>
                    {/* Price of Additional number USD */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Price of Each Additional Number, per month (USD)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                    </div>
                    {/* Inbound and Internal Calls */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Inbound Calls & Internal Calls (Toll-free Excluded)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                      </div>
                    </div>
                    {/* Outbound Calls-Domestic */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Outbound Calls-Domestic
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* Outbound Calls- International */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Outbound Calls - International
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                    </div>
                    {/* SMS and MMS*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          SMS AND MMS Business Text Messaging - Domestic
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        RSA Only: <br />
                        Contact us for rates
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        RSA Only: <br />
                        Contact us for rates
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        RSA Only: <br />
                        Contact us for rates
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        RSA Only: <br />
                        Contact us for rates
                      </div>
                    </div>
                    {/* Access to Call Recordings */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Access To Call Recordings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Up to 3 months
                        <br /> (by request, 6 months available in Dashboard)
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited <br />
                        (by request, 6 months available in Dashboard)
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                        <br /> (by request, 6 months available in Dashboard)
                      </div>
                    </div>
                    {/* Access Voicemail */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Price of Each Additional Number, per month (USD)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        30 Days
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        90 Days
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        6 Months
                      </div>
                      <div className="w-100 w--min-220 text-center">1 year</div>
                    </div>
                    {/* Analytics Data */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Analytics Data
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Up to 3 months
                        <br /> (Basic Analytics)
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Up to 3 months
                        <br /> (Basic Analytics)
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Up to 6 months
                        <br /> (Basic and Advanced Analytics)
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited <br /> (Analytics+)
                      </div>
                    </div>
                    {/* Number Porting Fee */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Number Porting Fee
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12 ? (
                              <p className="text--black">
                                {plan.free_did_number} Free Number
                              </p>
                            ) : (
                              <p>N/A</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* Additional Port Numbers*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Additional Number For Porting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R195.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R195.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R195.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R195.00
                      </div>
                    </div>
                    {/* Phone Number */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Phone Number
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* Voicemail */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Voicemail</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* Caller Id */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Caller ID</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* Incoming call custom ringer */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Incoming Call Custom Ringer
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* Custom music on hold */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Custom Music On Hold
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* SIP DESK Phone */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          SIP Desk Phone
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                    </div>
                    {/* Bussiness contacts */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Business Contacts
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12 ? (
                              <p className="text--black">
                                {plan.business_contacts}
                              </p>
                            ) : (
                              <p>N/A</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* Tollfree number */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Toll-Free Number (0800/0861)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R299 p/m
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R249 p/m
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R199 p/m
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R199 p/m
                      </div>
                    </div>
                    {/* SMS */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">SMS Bundle</p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12
                              ? `${plan.sms}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* Storage */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Call Recording and Voicemail Storage
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12
                              ? `${plan.cloud_storage}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Customer Call Management starts here */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black ">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Customer Call Management
                    </h3>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/*1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          IVR/Call Menus
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Call Queues</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Callback Automation- Queue Callback
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Intelligent Routing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Collaboration*/}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Collaboration
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Transfer
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Forwarding
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Add Call</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Conference Call
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Phone Number Extentsion List
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Recording
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          After Call Work: Call Notes
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          After Call Work: Call Disposition
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*9  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Multiple Call Handling (Above 2 Channels)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Voicemail - Inbox
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*11  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Assign & Comment On Calls
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*12  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Shared Call Inbox
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*13  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Shared Contacts
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 14 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Search Call Recordings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 15 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Note Creation
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 9 && plan.planID <= 12
                              ? `${plan.notes}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Productivity */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Productivity
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Business Hours
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Working Hours
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Mobile & Desktop Applications
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Advanced Appointment scheduling
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Note Taking</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Tags</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Block Calls</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Do Not Disturb / Do Not Call - Softphone
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Do Not Disturb / Do Not Call - Hardphone
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Agent management & Performance */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Agent Management & Performance
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Ratings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Analytics (Basic)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          SMS Analytics
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Analytics
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Advanced Analytics & Reporting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Messaging Features */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Messaging Features
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          SMS (1 Way Comms)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Bulk SMS Campaigns
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          WhatsApp Inbox
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          SMS Bots(Virtual Agents)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Coming Soon
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Coming Soon
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Coming Soon
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Coming Soon
                      </div>
                    </div>
                  </div>
                </div>

                {/* Phone System Features */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Phone System Features
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Instant Numbers
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Custom Music & Messages
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Business Hours
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Add/Buy Number
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">5</div>
                      <div className="w-100 w--min-220 text-center">10</div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                      </div>
                    </div>
                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Flow (Basic)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Time & Date Based Routing - IVR
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Smart Routing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Queue Callback
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*9  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Ring Groups</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Flexiable Call Distribution Rules
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*11  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Extensions</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*12  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Recording
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*13  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Tags</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 14 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Availability statuses - Call dispositions
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 15 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Mandatory tagging
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 16 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Analytics</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 17 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Standard Analytics
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 18 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Live Monitoring
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 19 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Forward-to-Mobile
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 20 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Click To Dial
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 21 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Desktop Notifications
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 22 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Warm Transfers
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 23 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          After Call Work
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 24 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Pause/Resume Recording
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 25 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Power Dialer
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Email reporting */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Email Reporting
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Email Reporting (Call Back)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Voicemail By Email
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Stats Report - Daily Agent
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Stats Report - Daily Manager
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* AI-transcription */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      AI & Transcription
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Transcription
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Summaries
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Scoring
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/*Apps & Intergration */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Admin & Security
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Role-Based Permissions
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Google Sign-In
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          SAML Single Sign-On
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Two-Factor Authentication (2FA)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/*  Customer Support*/}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Customer Support
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Help Center Access Chat
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Email Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Phone Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Standard Onboarding (11 Users Minimum)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Premium Onboarding(Hands-on Set Up)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Prioritized Customer Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Onboarding Via Help Center
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* footer start here */}
              <div className="subscriptions-plan-modal-footer w-100 d-flex align-items-start gap--15 mt--15 pt--12 pb--12 bg--white">
                <div className="subscription-left-content w--260 w--min-220 d-flex align-items-start gap--10">
                  <h3 className="font--14 text--black plan-title position-relative mb--5">
                    Price
                  </h3>
                </div>
                <div className="subscription-right-content w-100 d-flex align-items-start gap--15">
                  <div className="w-100 w--min-220 text-left">
                    <p className="font--12 text--black lh--19 mb-0">
                      Billed monthly, from
                    </p>
                  </div>
                  {plans_list.length > 0 ? (
                    plans_list.map((plan) => {
                      const planCost = isAnnual
                        ? plan.yearly_cost?.amount
                        : plan.monthly_cost?.amount;
                      const currencySymbol =
                        plan.currency === "USD"
                          ? "$"
                          : plan.currency === "ZAR"
                          ? "R"
                          : "N/A"; // Add more currencies as needed

                      return (
                        <div
                          key={plan.planID}
                          className="w-100 w--min-220 text-center"
                        >
                          {plan.planID >= 9 && plan.planID <= 10 ? (
                            <>
                              <div className="w-100 h--min-65 text-center">
                                <h3 className="font--16 text--black fw--600 mb--5">
                                  {`${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`}
                                </h3>
                              </div>
                              <a href="https://nxa.tel/signup">
                                {" "}
                                <span className="btn bg--orange-ea7414 border--orange-ea7414 pt--5 pb--5 pr--20 pl--20 radius--8 font--15 text--white dm--sans fw--700">
                                  Try for Free
                                </span>
                              </a>
                            </>
                          ) : (
                            <>
                              <div className="w-100 h--min-65 text-center">
                                <h3 className="font--16 text--black fw--600 mb--5">
                                  {`${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`}
                                </h3>
                              </div>
                              <a href="https://nxa.tel/demo">
                                {" "}
                                <span className="btn bg--orange-ea7414 border--orange-ea7414 pt--5 pb--5 pr--20 pl--20 radius--8 font--15 text--white dm--sans fw--700">
                                  Get Demo
                                </span>
                              </a>
                            </>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="w-100 w--min-220 text-center">
                      Loading...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PhoneComparisonModal;
